module.exports = __webpack_public_path__ + "static/media/08.f93b612b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/08.jpg
// module id = 269
// module chunks = 0